import './GalleryA.scss';

import { b2x } from '@b2x/react/src';

import { Container } from '../Container';

export interface GalleryAContentType {
  slides?: b2x.contentTypes.ContentSectionList<{
    asset?: b2x.contentTypes.AssetContentSectionV2;
    assetHover?: b2x.contentTypes.AssetContentSectionV2;
    cta?: b2x.contentTypes.CtaContentSection;
  }>;
}

interface GalleryAProps extends GalleryAContentType {}

export const GalleryA = ({ slides }: GalleryAProps) => {
  return (
    <b2x.Div className="gallery-a">
      <Container fluid="always">
        <b2x.Div>
          <b2x.SwiperContext>
            <b2x.Swiper
              breakpoints={{
                lg: { spaceBetween: 0 },
                md: { slidesPerView: 3.25, spaceBetween: 16 },
                xs: { slidesPerView: 1.15 },
              }}
              slides={slides?.map((slide) => (
                <b2x.Div className="slide-container" key={slide.contentSectionId}>
                  <b2x.AssetV2 {...slide.asset} />
                  <b2x.Div className="slide-hover">
                    <b2x.AssetV2 {...slide.assetHover} />
                    <b2x.Div
                      alignItems={'center'}
                      className="position-relative h-100 w-100"
                      display={'flex'}
                      justifyContent={'center'}
                    >
                      <b2x.CtaFromContent
                        {...slide.cta}
                        ctaProps={{ button: { className: 'stretched-link' } }}
                        variant="outline-secondary"
                      />
                    </b2x.Div>
                  </b2x.Div>
                </b2x.Div>
              ))}
            />
          </b2x.SwiperContext>
        </b2x.Div>
      </Container>
    </b2x.Div>
  );
};
